import './App.css';

function App() {
  return (
    <div className="container">
      <div className="logo-container">
        <div className="logo">
          <div className="logo-inner"><img src="img/saint-01.png" alt="" /></div>
        </div>
        <h1 className="logo-text">Saint Torus</h1>
        <p className="tagline">Tu socio en transformación digital</p>
      </div>

      <h2 className="construction">Sitio en Construcción</h2>

      <div className="loader">
        <div className="loader-dot"></div>
        <div className="loader-dot"></div>
        <div className="loader-dot"></div>
      </div>

      <p className="message">
        Estamos trabajando para ofrecerte <span className="highlight">soluciones tecnológicas integrales</span> que impulsen la transformación digital de tu empresa.
      </p>

      <p className="message">
        Pronto tendremos todo lo necesario para ser <span className="highlight">tu socio tecnológico de confianza</span>.
      </p>

      <div className="contact-info">
        {/*<p>---</p>*/}
        {/*<p>---</p>*/}

        <div className="social-icons">
          <a href="https://www.instagram.com/saint_torus/" className="social-icon">in</a>
          {/*<a href="#" className="social-icon">f</a>*/}
          {/*<a href="#" className="social-icon">t</a>*/}
        </div>
      </div>
    </div>
  );
}

export default App;